import {Layout} from '@sdox/ui'

import {TocSkeleton} from './TocSkeleton'
import {Section} from '../Section'

const TextSkeleton = () => (
  <div
    role={'status'}
    data-cy={'loading'}
  >
    <div className={'mb-spacing-16 h-spacing-16 w-[200px] animate-pulse bg-gray-300'}></div>
    <div className={'mb-spacing-10 h-spacing-8 animate-pulse bg-gray-300'}></div>
    <div className={'mb-spacing-10 h-spacing-8 animate-pulse bg-gray-300'}></div>
    <div className={'h-spacing-8 animate-pulse bg-gray-300'}></div>
    <div className={'mt-spacing-16 flex animate-pulse items-center space-x-3'}>
      <div>
        <div className={'mb-spacing-8 h-spacing-10 w-spacing-128 bg-gray-300'}></div>
        <div className={'h-spacing-8 w-[200px] bg-gray-300'}></div>
      </div>
    </div>
    <span className={'sr-only'}>Loading...</span>
  </div>
)

export const DocumentSkeleton = () => (
  <Section.Container>
    <div className={'grid gap-y-[--gap-section]'}>
      <Section.Template data-cy={'loading'}>
        <Section.Pullout
          top={true}
          right={true}
          left={true}
          bottom={false}
        >
          <div className={'pullout-rounded-lg aspect-[16/9] animate-pulse bg-gray-300'}/>
        </Section.Pullout>
        <Section.Pullout
          top={false}
          right={false}
          left={false}
          bottom={false}
        >
          <TextSkeleton/>
        </Section.Pullout>
      </Section.Template>
      <Section.Template data-cy={'loading'}>
        <Section.Pullout
          top={false}
          right={false}
          left={false}
          bottom={false}
        >
          <TextSkeleton/>
        </Section.Pullout>
      </Section.Template>
    </div>
  </Section.Container>
)

export const DocumentContainerSkeleton = () => (
  <Layout.DocumentContainer>
    <DocumentSkeleton />
    <TocSkeleton />
  </Layout.DocumentContainer>
)
